import config from '../config.js';

// API client for WNBA survey backend

export async function getQuestions() {
  try {
    const response = await fetch(
      `${config.apiEndpoint}/questions`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': config.apiKey
        },
        body: JSON.stringify({
          campaign: config.campaign
        })
      }
    );
    
    if (!response.ok) {
      throw new Error(`Failed to fetch questions: ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching questions:', error);
    throw error;
  }
}

export async function submitResponses(payload) {
  try {
    const response = await fetch(
      `${config.apiEndpoint}/responses`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': config.apiKey
        },
        body: JSON.stringify(payload)
      }
    );
    
    if (!response.ok) {
      throw new Error(`Failed to submit responses: ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error submitting responses:', error);
    throw error;
  }
}

export function buildPayload(answers, recommendation, email, optInType) {
  // Build payload according to backend specification
  return {
    campaign: config.campaign,
    email: email,
    isAnonymous: false,
    
    // Question answers (full text)
    Fan_Identity: answers.q1?.text || '',
    Ideal_Game_Day_Experience: answers.q2?.text || '',
    Ideal_Season_Experience: answers.q3?.text || '',
    Benefit_Priority: answers.q4?.text || '',
    
    // Question tags (for segmentation)
    q1_tag: answers.q1?.tag || '',
    q2_tag: answers.q2?.tag || '',
    q3_tag: answers.q3?.tag || '',
    q4_tag: answers.q4?.tag || '',
    
    // Recommendation (frontend calculates this)
    rec_tool_recommendation: recommendation.plan,
    rec_tool_corporate_flag: recommendation.corporateFlag,
    rec_tool_premium_flag: recommendation.premiumFlag,
    rec_tool_completed: true,
    
    // Email capture type (CRITICAL for SFMC routing)
    rec_tool_opt_in_type: optInType // "transactional" | "marketing"
  };
}

// Google Analytics 4 event tracking
export function trackGA4Event(eventName, eventParams = {}) {
  if (typeof window !== 'undefined' && window.gtag && config.ga4MeasurementId) {
    window.gtag('event', eventName, {
      ...eventParams,
      campaign: config.campaign
    });
  }
}

// Predefined GA4 events
export const GA4Events = {
  surveyStarted: () => trackGA4Event('survey_started'),
  
  questionAnswered: (questionNumber, tag) => trackGA4Event('question_answered', {
    question_number: questionNumber,
    answer_tag: tag
  }),
  
  surveyCompleted: (recommendation) => trackGA4Event('survey_completed', {
    recommendation: recommendation.plan,
    premium_flag: recommendation.premiumFlag,
    corporate_flag: recommendation.corporateFlag
  }),
  
  emailCaptured: (optInType, recommendation) => trackGA4Event('email_captured', {
    opt_in_type: optInType,
    recommendation: recommendation.plan
  }),
  
  depositClicked: (plan) => trackGA4Event('deposit_clicked', {
    plan: plan
  }),
  
  faqOpened: () => trackGA4Event('faq_opened')
};
